import { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { trackEcommerce, trackEvent } from 'dibs-tracking';
import { getCategories } from '../../utils/categoryHelpers';
import { pageTypeConstants as pageTypes } from '../../constants/pageTypeConstants';
import { ECOMMERCE_ATTRIBUTES } from '../../constants/attributesConstants';

const getPageLevel = ({ appliedFilters }) => {
    const categories = getCategories(appliedFilters);
    return categories.length;
};

class SbSharedCategoryTilesTrackingComponent extends Component {
    constructor() {
        super();

        this.fireTracking = this.fireTracking.bind(this);
        this.trackClick = this.trackClick.bind(this);
    }

    componentDidMount() {
        this.fireTracking();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.itemSearch.displayUriRef !== this.props.itemSearch.displayUriRef) {
            this.fireTracking();
        }
    }

    fireTracking() {
        const { itemSearch } = this.props;

        if (itemSearch.pageType === pageTypes.SEARCH) {
            trackEvent({
                category: 'promo interaction',
                action: 'broad search tiles displayed',
                label: `l${getPageLevel(itemSearch)}`,
            });
        } else {
            trackEcommerce({
                type: 'promotionImpression',
                promotions: this.getTrendingPromotions(),
            });
        }
    }

    trackClick(index) {
        const { itemSearch } = this.props;

        if (itemSearch.pageType === pageTypes.SEARCH) {
            trackEvent({
                category: 'promo interaction',
                action: 'broad search tiles clicked',
                label: `l${getPageLevel(itemSearch)}`,
            });
        } else {
            const promotions = this.getTrendingPromotions();
            trackEcommerce({
                type: 'promoClick',
                promotions: [promotions[index]],
            });
        }
    }

    getTrendingPromotions() {
        const { itemSearch, maxTilesAllowed } = this.props;
        const { appliedFilters = [], categoryTiles = [] } = itemSearch;
        let tiles = categoryTiles || [];
        tiles = maxTilesAllowed ? categoryTiles?.slice(0, maxTilesAllowed) : categoryTiles;

        const attributes = appliedFilters.filter(({ name }) => ECOMMERCE_ATTRIBUTES.includes(name));
        let trackingId = `L${getPageLevel(itemSearch) + 1}`;
        let trackingNameType = 'Result';

        if (attributes.length) {
            const attributeName = get(attributes, '[0].name');
            const attributeValue = get(attributes, '[0].values[0].urlLabel');
            trackingId =
                attributes.length > 1 ? 'multi-attribute' : `${attributeName}:${attributeValue}`;
            trackingNameType = 'Attribute';
        }

        return tiles.map((tile, i) => ({
            creative: tile.displayName,
            id: `${trackingId}-result-tiles`,
            name: `L${getPageLevel(itemSearch)}|${trackingNameType} Tiles`,
            position: i + 1,
            itemId: tile.itemId,
        }));
    }

    render() {
        const { trackClick } = this;
        return this.props.children({ trackClick });
    }
}

SbSharedCategoryTilesTrackingComponent.propTypes = {
    maxTilesAllowed: PropTypes.number,
    children: PropTypes.func.isRequired,
    itemSearch: PropTypes.object.isRequired,
};

export const SbSharedCategoryTilesTracking = createFragmentContainer(
    SbSharedCategoryTilesTrackingComponent,
    {
        itemSearch: graphql`
            fragment SbSharedCategoryTilesTracking_itemSearch on ItemSearchQueryConnection {
                displayUriRef
                pageType
                categoryTiles {
                    displayName
                    itemId
                }
                appliedFilters {
                    name
                    values {
                        urlLabel
                    }
                }
            }
        `,
    }
);
